const apiURL = "//spoon-inc.co.jp/cms/wp-json/spn/";

export const load = {
	getJson: function(url){
		console.log("getJson:", url);
		let fetchURL = apiURL + url;
		return fetch( fetchURL ).then( function(res){
			return res.json();
		}).then(function(data){
			return data;
		}).catch(function(error){
			return error
		});
	},
	postJson: function(url, param){
		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: param
		}
		return fetch(url, options).then( function(res){
			return res.json();
		}).then(function(data){
			return data;
		}).catch(function(error){
			return error
		});
	},
	getLocalJson: function(url){
		//console.log("getJson:", url);
		let fetchURL = url;
		return fetch( fetchURL ).then( function(res){
			return res.json();
		}).then(function(data){
			return data;
		}).catch(function(error){
			return error
		});
	}
}